/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AcceptTermsOptions, AcceptTermsResponses } from '../../models/AcceptTerms'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Accept Terms
 * {@link /user/terms/accept}
 */
export function acceptTerms<ThrowOnError extends boolean = true>(options: Options<AcceptTermsOptions, ThrowOnError> = {}): Promise<UnwrappedResult<AcceptTermsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/user/terms/accept', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AcceptTermsResponses, ThrowOnError>>
}
